import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui-components/blog-back-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.6_@babel+core@7.28.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
